// Locations
export const RequestedLocationCountDefault = 8;
export const MinLocationCount = 1;
export const MaxLocationCount = 10;

// Adventures
export const RequestedAdventuresCountDefault = 2;
export const MinAdventureCount = 1;
export const MaxAdventureCount = 4;

// Collab Summary
export const DaysCreatorsHaveToApply = 7;
export const DaysToChooseCreator = 10;

// Choose creator date constants
export const ChooseCreatorRecommendedDaysLimit = 8;
export const ChooseCreatorDaysLimitWithoutWarning = 14;
export const DaysBetweenOverlappingVisitChooseCreatorDates = 7;

// Collab Creation Steps
export enum CollabCreationSteps {
  Timing = 1,
  LocationsNAdventures = 2,
  LocationsAndActivities = 3,
  Themes = 4,
  Lodging = 5,
  GearNMaterial = 6,
  Boundaries = 7,
  Contact = 8,
  Name = 9,
}
